import RootState from '../../rootState';
import { ExperianQuestion, ConfirmIndentityRequest } from '../../../models/question';

export class Action {
    type: string;
    experianQuestions: Array<ExperianQuestion>;

    confirmIdentityAnswer: ConfirmIndentityRequest;
    isPass: boolean;
    errorMessage: string;
}

export interface State {
    experianQuestions: Array<ExperianQuestion>;

    submitting: boolean;
    submitted: boolean;
    isPass: boolean;
    errorMessage: string;
}

export const types = {
    STORE_EXPERIAN_QUESTION_DATA: 'STORE_EXPERIAN_QUESTION_DATA',

    SUBMIT_EXPERIAN_ANSWERS_ASYNC: 'SUBMIT_EXPERIAN_ANSWERS_ASYNC',
    SUBMIT_EXPERIAN_ANSWERS_SUCCEED: 'SUBMIT_EXPERIAN_ANSWERS_SUCCEED',
    SUBMIT_EXPERIAN_ANSWERS_FAILED: 'SUBMIT_EXPERIAN_ANSWERS_FAILED',

    // New Step02
    SUBMIT_EXPERIAN_QUESTIONS_ASYNC: 'SUBMIT_EXPERIAN_QUESTIONS_ASYNC',
    SUBMIT_EXPERIAN_QUESTIONS_SUCCEED: 'SUBMIT_EXPERIAN_QUESTIONS_SUCCEED',
    SUBMIT_EXPERIAN_QUESTIONS_FAILED: 'SUBMIT_EXPERIAN_QUESTIONS_FAILED',
};

const baseAction = new Action();

export const actions = {
    storeExperianQuestionData: (experianQuestions: Array<ExperianQuestion>): Action => ({
        ...baseAction,
        type: types.STORE_EXPERIAN_QUESTION_DATA,
        experianQuestions: experianQuestions
    }),

    submitExperianAnswersAsync: (confirmIdentityAnswer: ConfirmIndentityRequest): Action => ({
        ...baseAction, type: types.SUBMIT_EXPERIAN_ANSWERS_ASYNC,
        confirmIdentityAnswer
    }),

    submitExperianAnswersSucceeded: (isPass: boolean): Action => ({
        ...baseAction,
        type: types.SUBMIT_EXPERIAN_ANSWERS_SUCCEED,
        isPass
    }),

    actionServerDataFailed: (errorMessage: string): Action => ({
        ...baseAction,
        type: types.SUBMIT_EXPERIAN_ANSWERS_FAILED,
        errorMessage
    }),

    submitExperianQuestionsAsync: (confirmIdentityAnswer: ConfirmIndentityRequest): Action => ({
        ...baseAction, type: types.SUBMIT_EXPERIAN_QUESTIONS_ASYNC,
        confirmIdentityAnswer
    }),

    submitExperianQuestionsSucceeded: (isPass: boolean): Action => ({
        ...baseAction,
        type: types.SUBMIT_EXPERIAN_QUESTIONS_SUCCEED,
        isPass
    }),

    submitExperianQuestionsFailed: (errorMessage: string): Action => ({
        ...baseAction,
        type: types.SUBMIT_EXPERIAN_QUESTIONS_FAILED,
        errorMessage
    }),
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.experianQuestionData,

    getExperianQuestion(rootState: RootState): Array<ExperianQuestion> {
        const { experianQuestions } = this.getState(rootState);
        return experianQuestions;
    },

    submitting(rootState: RootState): boolean {
        const { submitting } = this.getState(rootState);
        return submitting;
    },

    submitted(rootState: RootState): boolean {
        const { submitted } = this.getState(rootState);
        return submitted;
    },

    isPass(rootState: RootState): boolean {
        const { isPass } = this.getState(rootState);
        return isPass;
    },

    getErrorMessage(rootState: RootState): string {
        const { errorMessage } = this.getState(rootState);
        return errorMessage;
    },
};


// WEBPACK FOOTER //
// ./src/modules/entities/experianQuestion/index.ts